import i18n from "@/i18n"
import React from "react"
import styled from "styled-components"
import { Trans } from "react-i18next"
import { useSelector } from 'react-redux';

const BottomWrapper = styled.section`
    display: flex;
    width: 900px;
    max-width: 100%;
    flex-direction: column;
    line-height: 1;
`

const HeadingSection = styled.div`
    background-color: #000;
    display: flex;
    width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.56px;
    justify-content: center;
    padding: 120px 20px 20px;
`

const HeadingWrapper = styled.div`
    display: flex;
    align-items: start;
    gap: 4px;
`

const GreenText = styled.h2`
    color: #83c308;
`

const WhiteText = styled.h2`
    color: #fff;
`

const ButtonSection = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    padding: 20px 10px;
`

const ActionButton = styled.button`
    border-radius: 8px;
    border: none;
    background-color: #fff;
    position: relative;
    display: flex;
    min-height: 44px;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 12px 10px;
    cursor: pointer;
`

const ButtonText = styled.span`
    color: #000;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.4px;
    text-align: center;
    z-index: 0;
`

const GreenSpan = styled.span`
    color: #83c308;
`

const PlusIcon = styled.span`
    color: #83c308;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: -0.2px;
    position: absolute;
    left: 54.5%;
    top: 8px;
    width: 8px;
    height: 13px;

	&.en {
		left: 51.5%;
	}

	&.jp {
		left: 58.3%;
	}
`

const Wrapper = styled.main`
    background-color: #000;
    align-self: stretch;
    display: flex;
    width: 100%;
    padding: 0 0 60px;
    flex-direction: column;
    align-items: center;
`

const ButtonWrapper = styled.div`
    align-self: start;
    position: absolute;
    z-index: 0;
    display: flex;
    min-width: 240px;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    color: rgb(34, 34, 34);
    font-weight: 800;
    text-align: center;
    letter-spacing: -0.4px;
    line-height: 1;
    justify-content: center;
    right: -1px;
    bottom: -1px;
    width: 388px;
    padding: 20px;
`

const Button = styled.button`
    align-self: stretch;
    border-radius: 8px;
    background-color: rgb(182, 255, 40);
    min-height: 44px;
    width: 100%;
    border: none;
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
    cursor: pointer;
    padding: 12px 10px;
    font-weight: 700;
`

const ContentWrapper = styled.div`
    z-index: 0;
    display: flex;
    min-width: 240px;
    flex-direction: column;
    overflow: hidden;
    justify-content: start;
    margin: auto 0;
    padding: 20px;
`

const TitleWrapper = styled.div`
    align-self: start;
    display: flex;
    flex-direction: column;
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.56px;
    line-height: 36px;
    justify-content: start;
`

const CTATitle = styled.h1`
    color: rgb(131, 195, 8);
    margin: 0;
    text-align: left;
    line-height: 40px;
`

const CTASubTitle = styled.h2`
    color: #fff;
    margin: 4px 0 0;
    text-align: left;
    line-height: 44px;
    font-weight: 600;
    letter-spacing: -2.5px;
`

const CTADescription = styled.p`
    color: rgb(212, 212, 212);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.32px;
    margin: 10px 0 0;
    text-align: left;
`

const CTAContainer = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
`

const CTAWrapper = styled.article`
    position: relative;
    display: flex;
    justify-content: center;
`

const CTAImage = styled.img`
    aspect-ratio: 1.1;
    object-fit: contain;
    object-position: center;
    width: 428px;
    border-radius: 12px;
    z-index: 0;
    min-width: 240px;
`

function CTAButton({ history }) {
    return (
        <ButtonWrapper>
            <Button
                onClick={() => history.push('/payment')}
            >
                {i18n.t("common.landing.cta.btn")}
            </Button>
        </ButtonWrapper>
    )
}

function CTAContent() {
    return (
        <ContentWrapper>
            <TitleWrapper>
                <CTATitle>
					<Trans i18nKey="common.landing.cta.title">
                        <br />
                    </Trans>
				</CTATitle>
                <CTASubTitle>
					<Trans i18nKey="common.landing.cta.subtitle">
                        <br />
                    </Trans>
				</CTASubTitle>
            </TitleWrapper>
            <CTADescription>
            	<Trans i18nKey="common.landing.cta.des">
                    <br />
                </Trans>
            </CTADescription>
        </ContentWrapper>
    )
}


function AdStudioCTA({ history }) {
    return (
        <main>
            <CTAContainer>
                <CTAWrapper>
                    <CTAContent />
                    <CTAImage
                        loading="lazy"
                        src="https://front.videomonster.com/images-7cuytg20/common/newlanding2024/gen_studio_temp.png"
                        alt="Advertisement studio showcase"
                    />
                    <CTAButton history={history} />
                </CTAWrapper>
            </CTAContainer>
        </main>
    )
}

function BottomContent({ history }) {
	const lang = useSelector(state => state.langStore.lang);
    return (
        <BottomWrapper>
            <HeadingSection>
                <HeadingWrapper>
                    <GreenText>{i18n.t("common.landing.cta.text_1")}</GreenText>
                    <WhiteText>{i18n.t("common.landing.cta.text_2")}</WhiteText>
                </HeadingWrapper>
            </HeadingSection>
            <ButtonSection>
                <ActionButton
                    onClick={() => history.push('/payment')}
                >
                    <ButtonText>
                        {i18n.t("common.landing.top.banner.videomonster")} <GreenSpan>{i18n.t("common.landing.top.banner.plus")}</GreenSpan> {i18n.t("common.landing.cta.start")}
                    </ButtonText>
                    <PlusIcon className={lang}>+</PlusIcon>
                </ActionButton>
            </ButtonSection>
        </BottomWrapper>
    )
}

export default function GenStudio({ history }) {
    return (
        <Wrapper>
            <AdStudioCTA history={history} />
            <BottomContent history={history} />
        </Wrapper>
    )
}